/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, buildingName: NonNullable<unknown> }} Building_Users_DeleteInputs */

const fr_building_users_delete = /** @type {((inputs: Building_Users_DeleteInputs) => LocalizedString) & { parts: (inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Users_DeleteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Êtes vous sûre de vouloir supprimer ${i?.name} de votre bâtiment ${i?.buildingName} ?`)
		}),
		{
			parts: /** @type {(inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Êtes vous sûre de vouloir supprimer " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.name) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " de votre bâtiment " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.buildingName) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " ?" }])
			})
		}
	)
);

const en_building_users_delete = /** @type {((inputs: Building_Users_DeleteInputs) => LocalizedString) & { parts: (inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Users_DeleteInputs) => LocalizedString} */ ((i) => {
			return /** @type {LocalizedString} */ (`Are you sure you want to remove ${i?.name} from your building ${i?.buildingName}?`)
		}),
		{
			parts: /** @type {(inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[]} */ ((i) => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Are you sure you want to remove " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.name) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: " from your building " }, { type: "markup-start", name: "span", options: {}, attributes: {} }, { type: "text", value: String(i?.buildingName) }, { type: "markup-end", name: "span", options: {}, attributes: {} }, { type: "text", value: "?" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Are you sure you want to remove {name} from your building {buildingName}?" |
*
* @param {Building_Users_DeleteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_users_delete = /** @type {((inputs: Building_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs: Building_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Building_Users_DeleteInputs, { locale?: "fr" | "en" }, { span: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Building_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_building_users_delete(inputs)
			return fr_building_users_delete(inputs)
		}),
		{
			parts: /** @type {(inputs: Building_Users_DeleteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (en_building_users_delete).parts?.(inputs) ?? [{ type: "text", value: en_building_users_delete(inputs) }]
				return /** @type {{ parts?: (inputs: Building_Users_DeleteInputs) => import('../runtime.js').MessagePart[] }} */ (fr_building_users_delete).parts?.(inputs) ?? [{ type: "text", value: fr_building_users_delete(inputs) }]
			})
		}
	)
);